import React from 'react'
import { CheckboxSingleControl } from 'formik-chakra-ui'
import { Link, Flex } from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import { NbSp } from '../../../../utils/NbSp'
import { UserExtraValidationSchemaEnum } from 'shared/entities-validator/user-fields-validators'

type PrivacyPolicyCheckboxProps = {
  policyUrl: string
}

export const PrivacyPolicyCheckbox: React.FC<PrivacyPolicyCheckboxProps> = ({
  policyUrl
}) => {
  return (
    <Flex align="center" my="20px">
      <CheckboxSingleControl
        name={UserExtraValidationSchemaEnum.PRIVACY_POLICY}
      >
        <Trans>
          I agree to the
          <NbSp />
          <Link href={policyUrl} target="_blank">
            Privacy Policy
          </Link>
        </Trans>
      </CheckboxSingleControl>
    </Flex>
  )
}
